import React, { useState } from "react";
import { toast } from "react-toastify";
import AppButton from "../shared/AppBtn";
import ErrorTag from "../shared/Error";
// import { useHistory } from "react-router-dom";
import { sendEmailService } from "../../core/services/admin.service";

const RequestDeletion = () => {
	// const history = useHistory();
	const [errorMessage, setErrorMessage] = useState("");
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState({
		firstName: "",
		lastName: "",
		username: "",
		reasons: "",
		dataType: "My Account",
	});
	const [dataTypeOptions, _] = useState(["My Account", "User Data", "Trasaction Data"]);

	const handleSubmit = async (e) => {
		setLoading(true);
		e.preventDefault();
		const { username, firstName, lastName, dataType, reasons } = data;

		if (!username || !firstName || !lastName) {
			toast.error("Missing fields");
			return;
		} else if (!dataType) {
			// setErrorMessage("Select Data type");
			toast.error("Select Data Type");
		} else {
			const dataObj = {
				firstName, 
				lastName,
				username,
				reasons,
				dataType
			}
			const args =  JSON.stringify(dataObj)
			const payload = {
				emails: ['customercare@ileero.com'],
				emailRefDataKey: "USER_REQUEST",
				emailSubject: "Ileero Remit - User Request",
				args:  args,
			};
			const res = await sendEmailService(payload);
			if(res){
				toast.success("Request succesfully submitted !");
				setData({
					firstName: "",
					lastName: "",				 
					username: "",				 
					dataType: "",
					reasons: "",
				});

			}
			setLoading(false);
		}
		setLoading(false);
	};

	const HandleChange = (e) => {
		setErrorMessage("");
		setData({ ...data, [e.target.name]: e.target.value });
		// toast.success("Account created successfully");
	};
	return (
		<>
			<div className="container w-50 d-flex  p-5 justify-content-center ">
				<div className="w-100">
					<form onSubmit={handleSubmit}>
						{" "}
						<ErrorTag msg={errorMessage} />
						<div className="form-group position-relative mb-3">
							<label
								className=" font-weight-bold col-form-label"
								htmlFor=""
							>
								Which data would you like to be deleted?
							</label>
							<select
								className="form-control"
								id="location"
								placeholder="phone Number"
								name="dataType"
								value={data.dataType}
								onChange={HandleChange}
							>
								{" "}
								{dataTypeOptions &&
									dataTypeOptions.map((val, index) => (
										<option
											data-id={index}
											key={index}
											value={val}
										>
											{val}
										</option>
									))}{" "}
							</select>
						</div>
						<div className="form-group">
							<label
								className=" font-weight-bold col-form-label"
								htmlFor=""
							>
								First Name
							</label>
							<input
								type="text"
								className="form-control "
								id="firstName"
								placeholder="First Name"
								name="firstName"
								value={data.firstName}
								onChange={HandleChange}
							/>
						</div>
						<div className="form-group">
							<label
								className=" font-weight-bold col-form-label"
								htmlFor=""
							>
								Last Name
							</label>

							<input
								type="text"
								className="form-control "
								id="lastName"
								placeholder="Last Name"
								name="lastName"
								value={data.lastName}
								onChange={HandleChange}
							/>
						</div>
						<div className="form-group">
							<label
								className=" font-weight-bold col-form-label"
								htmlFor=""
							>
								Email Address
							</label>

							<input
								type="email"
								className="form-control "
								id="username"
								placeholder="Email Address"
								name="username"
								value={data.username}
								onChange={HandleChange}
							/>
							<p
								className="text-seconadary"
								style={{ fontSize: "12px" }}
							>
								{" "}
								*Must be the email address you registered with
							</p>
						</div>
						<div className="form-group">
							<textarea
								// cols={5}
								rows={5}
								className="form-control "
								id="reasons"
								placeholder="Reason"
								name="reasons"
								value={data.reasons}
								onChange={HandleChange}
							/>
						</div>
						<AppButton
							value={loading ? ".....loading" : 'Submit Request'}
							type="submit"
							showLoader
							isLoading={loading}
							disabled={!data.username || !data.dataType || loading}
						/>
					</form>
				</div>
			</div>
			<div className="d-flex justify-content-center ">
				<section className="col-sm-4 pp-who-we-are my-5  mx-3 bg-white shadow   rounded p-5">
					<h3 className="mb-3">Assurance that data is safe </h3>
					<p>
						We are committed to protecting your personal data and being transparent about the personal data we hold and
						use and, wherever possible, giving you control over how we use your personal data.
					</p>
				</section>
				<section className=" col-sm-4 pp-who-we-are my-5 mx-3  shadow rounded p-5">
					<h3 className="mb-3">Data retention Policy</h3>
					<p>
						To ensure that ileero Pay products and services are not used to commit fraud, money laundering and/or
						terrorist financing. To ensure ileero Pay complies with all regulatory compliance requirements and safe
						gurards its customers. Customer records are stored inline with company records retention policy for
						non-business customers and business customers.
					</p>
				</section>
			</div>
		</>
	);
};

export default RequestDeletion;
